import * as React                          from 'react'
import { FormattedDate, FormattedMessage } from 'react-intl'

import { Session, SessionStatus } from '../../api'
import * as colors                from '../../theme'

import TableCell from '@material-ui/core/TableCell'
import TableRow  from '@material-ui/core/TableRow'
import Done      from '@material-ui/icons/Done'
import Schedule  from '@material-ui/icons/Schedule'

interface SessionTableRowProps {
  session: Session
  rowLabel: number | string
  onSessionClick: () => void
}

const SessionTableRow: React.SFC<SessionTableRowProps> = ({
  session,
  rowLabel,
  onSessionClick,
}) => {
  const phrasing = { na: <FormattedMessage id={'dictionary.na'} /> }

  let statusIcon

  switch (session.status) {
    case SessionStatus.Done:
      statusIcon = <Done nativeColor={colors.success.main} />
      break

    case SessionStatus.Scheduled:
      statusIcon = <Schedule nativeColor={colors.success.main} />
      break

    case SessionStatus.Pending:
      statusIcon = <Schedule nativeColor={'grey'} />
      break
  }

  const { date } = session

  const displayedDate = date
    ? (
      <FormattedDate
        value={date}
        year={'numeric'}
        month={'2-digit'}
        day={'2-digit'}
      />
    )
    : phrasing.na

  const displayedTime = date
    ? (
      <FormattedDate
        value={date}
        hour={'2-digit'}
        minute={'2-digit'}
      />
    )
    : phrasing.na

  const sessionIsDone = session.status === SessionStatus.Done

  const className = sessionIsDone ? 'cursor-pointer' : ''

  return (
    <TableRow
      hover={sessionIsDone}
      onClick={onSessionClick}
      className={className}
    >
      <TableCell>
        {rowLabel}
      </TableCell>
      <TableCell>
        {statusIcon}
      </TableCell>
      <TableCell numeric>
        {displayedDate}
      </TableCell>
      <TableCell numeric>
        {displayedTime}
      </TableCell>
    </TableRow>
  )
}

export default SessionTableRow



// WEBPACK FOOTER //
// ./src/components/molecules/SessionTableRow.tsx